module.exports = {
	"id": "MD",
	"name": "Moldova",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.124635,
			"5": 0.141253,
			"6": 0.091399,
			"7": 0.074781,
			"8": 0.108017,
			"9": 0.099708,
			"10": 0.141253,
			"11": 0.132944,
			"12": 0.191107,
			"13": 0.132944,
			"14": 0.232652,
			"15": 0.216034,
			"16": 0.282506,
			"17": 0.224343,
			"18": 0.357287,
			"19": 0.232652,
			"20": 0.290815,
			"21": 0.540085,
			"22": 0.373905,
			"23": 0.33236,
			"24": 0.340669,
			"25": 0.240961,
			"26": 0.324051,
			"27": 0.265888,
			"28": 0.199416,
			"29": 0.041545,
			"30": 0.024927,
			"31": 0.058163,
			"32": 0.124635,
			"33": 0.091399,
			"34": 0.099708,
			"35": 0.24927,
			"36": 0.116326,
			"37": 0.08309,
			"38": 0.091399,
			"39": 0.448686,
			"40": 0.490231,
			"41": 0.307433,
			"42": 0.232652,
			"43": 0.324051,
			"44": 0.074781,
			"45": 0.099708,
			"46": 0.066472,
			"47": 0.149562,
			"48": 0.307433,
			"49": 2.733661,
			"50": 0.24927,
			"51": 1.24635,
			"52": 0.573321,
			"53": 25.724664,
			"54": 7.503027,
			"55": 0.132944,
			"56": 0.033236,
			"57": null
		},
		"firefox": {
			"2": 0.207725,
			"3": 0.606557,
			"4": 0.108017,
			"5": 0.049854,
			"6": 0.033236,
			"7": 0.024927,
			"8": 0.091399,
			"9": 0.041545,
			"10": 0.08309,
			"11": 0.108017,
			"12": 0.066472,
			"13": 0.049854,
			"14": 0.08309,
			"15": 0.116326,
			"16": 0.074781,
			"17": 0.074781,
			"18": 0.058163,
			"19": 0.066472,
			"20": 0.116326,
			"21": 0.066472,
			"22": 0.08309,
			"23": 0.049854,
			"24": 0.024927,
			"25": 0.08309,
			"26": 0.049854,
			"27": 0.024927,
			"28": 0.041545,
			"29": 0.016618,
			"30": 0.033236,
			"31": 0.041545,
			"32": 0.049854,
			"33": 0.049854,
			"34": 0.091399,
			"35": 0.149562,
			"36": 0.149562,
			"37": 0.024927,
			"38": 0.058163,
			"39": 0.024927,
			"40": 0.024927,
			"41": 0.016618,
			"42": 0.033236,
			"43": 0.157871,
			"44": 0.066472,
			"45": 0.149562,
			"46": 0.116326,
			"47": 0.556703,
			"48": 0.24927,
			"49": 3.473162,
			"50": 0.024927,
			"51": null,
			"52": null,
			"3.5": 0.972153,
			"3.6": 2.933077
		},
		"opera": {
			"9": null,
			"11": 0.174489,
			"12": 1.179878,
			"15": 0.024927,
			"16": 0.033236,
			"17": 0.049854,
			"18": 0.091399,
			"19": 0.049854,
			"20": 0.124635,
			"21": 0.108017,
			"22": 0.024927,
			"23": 0.024927,
			"24": 0.049854,
			"25": 0.074781,
			"26": 0.124635,
			"27": 0.565012,
			"28": 0.058163,
			"29": 0.041545,
			"30": null,
			"31": null,
			"32": 0.008309,
			"33": null,
			"34": null,
			"35": 0.016618,
			"36": 0.149562,
			"37": 0.033236,
			"38": 0.182798,
			"39": 0.024927,
			"40": 1.171569,
			"41": 0.207725,
			"42": 0.016618,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.108017,
			"10.5": 0.16618,
			"10.6": 0.448686,
			"11.1": 0.141253,
			"11.5": 0.191107,
			"11.6": 0.922299,
			"12.1": 2.74197
		},
		"safari": {
			"0": null,
			"4": 0.365596,
			"5": 0.623175,
			"6": 0.108017,
			"7": 0.033236,
			"8": 0.058163,
			"9": 0.024927,
			"10": 0.465304,
			"3.1": 0.074781,
			"3.2": 0.024927,
			"5.1": 0.373905,
			"6.1": 0.024927,
			"7.1": 0.033236,
			"9.1": 0.191107
		},
		"ios_saf": {
			"8": 0,
			"10": 1.72469609659,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0464785641132,
			"8.1-8.4": 0.0858671777685,
			"9.0-9.2": 0.0409641582015,
			"9.3": 0.624966003331
		},
		"android": {
			"3": 0,
			"4": 0.0294854470284,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00368568087855,
			"4.1": 0.106358219638,
			"4.2-4.3": 0.265895549096,
			"4.4": 0.609716922481,
			"4.4.3-4.4.4": 0.614982180879
		},
		"ie": {
			"6": null,
			"7": 0.0270803795812,
			"8": 0.640902316754,
			"9": 0.406205693717,
			"10": 0.848518560209,
			"11": 1.52552804974,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0434977057427,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00120826960396
		},
		"edge": {
			"12": 0.033236,
			"13": 0.182798,
			"14": 0.33236
		},
		"ie_mob": {
			"10": 0.124038422535,
			"11": 0.505013577465
		},
		"bb": {
			"7": 0.00549575,
			"10": null
		},
		"samsung": {
			"0": 1.063639
		},
		"and_uc": {
			"0": 0.189392
		},
		"op_mini": {
			"0": 0.586037024653
		},
		"and_chr": {
			"0": 11.41325
		},
		"and_ff": {
			"0": 0.008455
		}
	},
	"total": 93.14001075
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MD.json
 ** module id = 584
 ** module chunks = 0
 **/